import React from 'react';
import useSchoolyears from 'queries/schoolyears/useSchoolyears';
import Select from 'components/Form/Select2';
import _orderBy from 'lodash-es/orderBy';
import { Schoolyear } from 'types/schoolyear';
import { useTranslation } from 'react-i18next';

interface Props {
  value: Schoolyear;
  disabled?: boolean;
  onChange: (v: Schoolyear) => void;
}

export function SchoolyearSelector(props: Props) {
  const { data, isLoading } = useSchoolyears();
  const schoolyears = data || [];
  const { t } = useTranslation(['common']);
  const { value } = props;
  return (
    <div>
      <Select
        loading={isLoading}
        disabled={props.disabled}
        large
        label={t('common:labels.schoolYear')}
        value={value?.id}
        options={_orderBy(schoolyears, 'year', ['desc']).map(scy => ({
          label: scy.label,
          value: scy.id,
        }))}
        onChange={v =>
          props.onChange(
            schoolyears.find(scy => scy.id === v) || schoolyears[0],
          )
        }
      />
    </div>
  );
}
